import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { accountingApi } from './api'
import { money, monthLabel, rollForwardRows } from './format'

type Rows = { rows: Record<string, unknown>[] }

/** Print view: the browser's "Save as PDF" makes the file for the records. */
export function PrintClosePage() {
  const { slug = '', period = '' } = useParams()
  const close = useQuery({ queryKey: ['accounting', 'close', slug, period], queryFn: () => accountingApi.close(slug, period) })
  const ed = useQuery({ queryKey: ['accounting', 'ed', slug, period], queryFn: () => accountingApi.report<Record<string, unknown>>(slug, period, 'earned-deferred') })
  const dbm = useQuery({ queryKey: ['accounting', 'dbm', slug, period], queryFn: () => accountingApi.report<Rows>(slug, period, 'deferred-by-month') })
  const ready = close.data && ed.data && dbm.data
  useEffect(() => { if (ready) setTimeout(() => window.print(), 300) }, [ready])
  if (!ready) return <p>Preparing…</p>
  const c = close.data!
  return (
    <article className="bg-white p-6 text-black">
      <h1 className="text-xl font-bold">{c.name} — {monthLabel(c.period)} close ({c.status})</h1>
      <h2 className="mt-4 font-bold">Roll-forward</h2>
      <table className="w-full max-w-xl"><tbody>{rollForwardRows(c.summary).map((r) => <tr key={r.label}><td className="whitespace-pre">{r.label}</td><td className="text-right">{r.gross}</td><td className="text-right">{r.net}</td></tr>)}</tbody></table>
      <h2 className="mt-4 font-bold">Earned/Deferred</h2>
      <table><tbody>{Object.entries(ed.data!).map(([k, v]) => <tr key={k}><td className="pr-4">{k}</td><td>{String(v)}</td></tr>)}</tbody></table>
      <h2 className="mt-4 font-bold">Deferred by month</h2>
      <table><thead><tr><th className="text-left">Month</th><th>Copies</th><th>Gross</th><th>Net</th></tr></thead>
        <tbody>{dbm.data!.rows.map((r) => <tr key={String(r.month)}><td>{String(r.month)}</td><td className="text-right">{String(r.copies)}</td><td className="text-right">{money(String(r.gross))}</td><td className="text-right">{money(String(r.net))}</td></tr>)}</tbody></table>
    </article>
  )
}
